/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize NephroPlusChat View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './NephroPlusChatView';

/**
 * Map state to props
 * @returns { object }
 */
export const mapStateToPropsNephroPlusChat = mapStateToProps;
export const mapDispatchToPropsNephroPlusChat = mapDispatchToProps;

export default connect(
  mapStateToPropsNephroPlusChat,
  mapDispatchToPropsNephroPlusChat
)(View);
